import type { OptionsType } from '@atlaskit/select';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { createErrorAnalytics } from '@atlassian/jira-polaris-lib-errors/src/controllers/index.tsx';
import { getJpdProjects, type GetJpdProjectsOptions } from '../services/index.tsx';
import type { ProjectOption } from './types.tsx';

export const loadProjectsOptions = async (
	options: GetJpdProjectsOptions,
): Promise<OptionsType<ProjectOption>> =>
	getJpdProjects(options)
		.then((projects) =>
			projects.map((project) => ({
				id: project.id,
				label: project.name,
				imageUrl: project.avatarUrls['16x16'],
				value: project.key,
				issueTypes: project.issueTypes,
			})),
		)
		.catch((error) => {
			fireErrorAnalytics(
				createErrorAnalytics('polaris.error.availableProjectsLoadingFailed', error),
			);
			throw error;
		});
